var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-role=\"filter-map-template\"></div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/filter-map-template.hbs
// module id = 37
// module chunks = 0